import { LocalizedText } from "@/common/common";
import { DCEvent, EventDispatcher, HttpEvent, updateStore } from "@/events/eventsDomain";
import { Language } from "@/i18n/languages";
import { updateUserPrefEvent, UserPrefs } from "@/stores/userPrefsDomain";
import { isBlank } from "@/utils/strings";

export type AnnouncementDTO = {
  announcementId: string;
  level: "success" | "info" | "warning" | "error";
  message: LocalizedText[];
};

export type GetAnnouncementResponse = {
  announcement?: AnnouncementDTO;
};

export const announcementApi = {
  getAnnouncement: (): HttpEvent<GetAnnouncementResponse> => ({
    type: "http",
    method: "get",
    url: "/announcement",
    onSuccess: (res) => [updateStore({ announcement: res.data.announcement })],
    onFailure: () => [],
  }),
};

export const showAnnouncement = (
  userPrefs: UserPrefs,
  lang: Language,
  announcement?: AnnouncementDTO,
): boolean =>
  announcement !== undefined &&
  userPrefs.dismissedAnnouncement !== announcement.announcementId &&
  !isBlank(announcementText(lang, announcement));

export const announcementText = (lang: Language, announcement?: AnnouncementDTO): string =>
  announcement?.message?.find((x) => x.language === lang)?.text ??
  announcement?.message[0]?.text ??
  "";

export const announcementLevel = (announcement?: AnnouncementDTO): AnnouncementDTO["level"] =>
  announcement?.level ?? "info";

export const dismissAnnouncement = (announcement?: AnnouncementDTO): DCEvent[] =>
  updateUserPrefEvent("dismissedAnnouncement", announcement?.announcementId);

export const pollAnnouncements = (dispatch: EventDispatcher) => {
  dispatch([announcementApi.getAnnouncement()]);
  setInterval(() => dispatch([announcementApi.getAnnouncement()]), 60_000);
};
